(function ($) {
    $(document).ready(function () {
        wrapFirstWord();
        hoverImages();
    });

    function wrapFirstWord() {
        const parent = $('#preview_destinations .preview_destinations_wrap .building');
        const string = parent.find('h4');

        string.each(function () {
            var me = $(this);
            me.html(me.html().replace(/^(\w+)/, '<span>$1</span>'));
        });
    }

    function hoverImages() {
        if (is_desktop) {

            const wrap = $(".preview_destinations_wrap");
            const dest1 = $("#destination_0");
            const text1 = dest1.find('h4');
            const dest2 = $("#destination_1");
            const text2 = dest2.find('h4');


            if (dest1.length !== 0 && dest2.length) {

                gsap.set(dest1, {flex: "0 0 50%", ease: "power3.out"});
                gsap.set(dest2, {flex: "0 0 50%", ease: "power3.out"});

                dest1.on("mouseenter", () => {
                    gsap.to(dest1, {duration: 0.6, flex: "0 0 60%", ease: "power3.out"});
                    gsap.to(text1, {duration: 0.3, color: "#B17E49", ease: "power3.out"});
                    gsap.to(text2, {duration: 0.3, color: "#FFF", ease: "power3.out"});
                    gsap.to(dest2, {duration: 0.6, flex: "0 0 40%", ease: "power3.out"});
                });

                dest2.on("mouseenter", () => {
                    gsap.to(dest2, {duration: 0.6, flex: "0 0 60%", ease: "power3.out"});
                    gsap.to(text1, {duration: 0.3, color: "#FFF", ease: "power3.out"});
                    gsap.to(text2, {duration: 0.3, color: "#B17E49", ease: "power3.out"});
                    gsap.to(dest1, {duration: 0.6, flex: "0 0 40%", ease: "power3.out"});
                });

                wrap.on("mouseleave", () => {
                    gsap.to(dest1, {duration: 0.6, flex: "0 0 50%", ease: "power3.out"});
                    gsap.to(text1, {duration: 0.3, color: "#FFF", ease: "power3.out"});
                    gsap.to(text2, {duration: 0.3, color: "#FFF", ease: "power3.out"});
                    gsap.to(dest2, {duration: 0.6, flex: "0 0 50%", ease: "power3.out"});
                });
            }
        }
    }
}(jQuery));